import React from 'react';

export default (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 19" { ...props }>
    <path d="M18.99 2.07c-2.02-2.1-5.29-2.1-7.3 0L10.5 3.3 9.32 2.07c-2.02-2.1-5.29-2.1-7.3 0C0 4.17 0 7.57 2.01 9.67L3.2 10.9l7.3 7.6 7.3-7.6 1.18-1.23c2.02-2.1 2.02-5.5.01-7.6z" />
  </svg>
);
